import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

type ClioConnectionConfirmModalProps = {
  open: boolean;
  manageAccountName: string;
  handleCancel: () => void;
  handleConfirm: () => void;
};

const ClioConnectionConfirmModal = ({
  open,
  manageAccountName,
  handleCancel,
  handleConfirm,
}: ClioConnectionConfirmModalProps) => {
  return (
    <Dialog open={open} onClose={handleCancel}>
      <DialogTitle>
        <div className="flex flex-col">
          <span className="text-lg font-semibold">
            Connect to your Clio Manage account
          </span>
        </div>
      </DialogTitle>
      <DialogContent dividers={true}>
        <div className="flex flex-col space-y-4">
          <span className="text-sm text-gray-600 mt-2">
            Matters and contacts from your Clio Manage account:{' '}
            <strong>{manageAccountName}</strong> will be imported into Clio
            Draft.
          </span>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClioConnectionConfirmModal;
